import React from 'react';
import { motion } from 'framer-motion';
import './ProductPayrollComplexity.css';

const ProductPayrollComplexity = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  const fadeInLeft = {
    hidden: { opacity: 0, x: -60 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  const fadeInRight = {
    hidden: { opacity: 0, x: 60 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="payroll-section">
      <div className="payroll-container">
        <motion.div 
          className="payroll-content"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeInLeft}
        >
          <motion.h2 
            className="payroll-title"
            variants={fadeInUp}
          >
            Built for Healthcare<br />Payroll Complexity
          </motion.h2>
          <motion.p 
            className="payroll-desc"
            variants={fadeInUp}
          >
            Handles shift-based pay, overtime, tax compliance, night duty, and more — so your team gets paid right, on time
          </motion.p>
        </motion.div>
        <motion.div 
          className="payroll-images"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeInRight}
        >
          <motion.img 
            src="/images/Payrollimg1.png" 
            alt="Add a bonus" 
            className="payroll-img"
            variants={fadeInUp}
            style={{ marginTop: '0' }}
          />
          <motion.img 
            src="/images/Payrollimg2.png" 
            alt="Run Payroll" 
            className="payroll-img"
            variants={fadeInUp}
            style={{ marginTop: '30px' }}
          />
          <motion.img 
            src="/images/Payrollimg3.png" 
            alt="Payroll Steps" 
            className="payroll-img"
            variants={fadeInUp}
            style={{ marginTop: '60px' }}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default ProductPayrollComplexity; 